import { render, staticRenderFns } from "./AdminReceipts.vue?vue&type=template&id=a37f93e4"
import script from "./AdminReceipts.vue?vue&type=script&lang=js"
export * from "./AdminReceipts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports